$(function() {
    //main Banner carousel
	$('.homeBannerCarousel__inner').flickity({
		adaptiveHeight: false,
		autoPlay: 5000,
		cellAlign: 'left',
		contain: true,
		draggable: true,
		pageDots: true,
		prevNextButtons: true,
		pauseAutoPlayOnHover: false,
		setGallerySize: true,
		wrapAround: true,
		on: {
			ready: function() {
				// Add pause button
				var pause = '<button class="flickity-button pause" type="button" aria-label="Pause alert carousel" aria-selected="false"></button>';
				$('.homeBannerCarousel__inner .flickity-page-dots').wrap('<div class="flickity-controls"/>');
				$(pause).insertAfter('.homeBannerCarousel__inner .flickity-page-dots');
			}
		}
	});

	$('.homeBannerCarousel__inner .flickity-button.pause').on('click', function() {
			let isPaused = $(this).attr('aria-selected') === 'true' ? true : false;

			$(this).attr('aria-selected', isPaused ? 'false' : 'true');
			$('.homeBannerCarousel__inner').flickity(isPaused ? 'playPlayer' : 'stopPlayer');
    });

    if (!window.matchMedia('(min-width: 1200px').matches) {
        $('.homeBannerCarousel__inner').flickity('stopPlayer');
    }
});
